import { create } from "zustand";
import type { Project, Folder, Style } from "../../../shared/db/types.js";

export interface WorkspaceState {
  projects: Project[];
  folders:  Folder[];
  styles:   Style[];
  loading:  boolean;

  setProjects: (projects: Project[]) => void;
  setFolders:  (folders: Folder[]) => void;
  setStyles:   (styles: Style[]) => void;
  setLoading:  (loading: boolean) => void;

  addProject: (project: Project) => void;
  addFolder:  (folder: Folder)   => void;
  addStyle:   (style: Style)     => void;
}

export const useWorkspaceStore = create<WorkspaceState>()((set) => ({
  projects: [],
  folders:  [],
  styles:   [],
  loading:  false,

  setProjects: (projects) => set({ projects }),
  setFolders:  (folders)  => set({ folders }),
  setStyles:   (styles)   => set({ styles }),
  setLoading:  (loading)  => set({ loading }),

  addProject: (project) => set((s) => ({ projects: [project, ...s.projects] })),
  addFolder:  (folder)  => set((s) => ({ folders: [...s.folders, folder] })),
  addStyle:   (style)   => set((s) => ({ styles:  [...s.styles,  style]  })),
}));
